var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-btn',{attrs:{"block":"","variant":"primary"},on:{"click":_vm.goCreate}},[_vm._v("Nuevo "),_c('i',{staticClass:"fa fa-plus fa-lg"})])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ced3c3a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/base/buttons/btnPlus.vue
// module id = null
// module chunks = 